import { useState } from "react"
import { Alert } from "@/types/types"
import clsx from "clsx"

type EditAlertThresholdProps = {
  onSubmit: (threshold: number) => Promise<void>
  buttonLabel?: string
  initialThreshold?: Alert["change_threshold"] | null
  isSubmitting?: boolean
}

const EditAlertThreshold = ({
  onSubmit,
  buttonLabel = "Done",
  initialThreshold = null,
  isSubmitting = false,
}: EditAlertThresholdProps) => {
  const [threshold, setThreshold] = useState<Alert["change_threshold"] | null>(
    initialThreshold
  )

  return (
    <div className="flex flex-1">
      <div className="-mr-2 flex flex-1 text-sm lg:mr-0">
        <div className="whitespace-no-wrap flex items-center pr-2 lg:pr-3">
          Alert at:
        </div>
        {[0.025, 0.05, 0.1, 0.15, 0.2, 0.25].map((value) => (
          <button
            key={value}
            onClick={() => setThreshold(threshold === value ? null : value)}
            className={clsx(
              "h-8 flex-1 self-center rounded",
              threshold === value
                ? "bg-gray-700 text-white"
                : "text-gray-500 hover:text-white"
            )}
          >
            {(value * 100).toFixed((value * 100) % 1 !== 0 ? 1 : 0)}%
          </button>
        ))}
      </div>
      <div className="absolute top-0 right-0 m-2 flex-none self-center lg:static lg:m-0 lg:pr-4 lg:pl-4">
        <button
          className={clsx(
            "relative h-8 justify-center rounded px-3 text-sm font-bold",
            threshold
              ? "bg-teal-550 hover:bg-teal-450"
              : "bg-gray-700 text-gray-500 opacity-50"
          )}
          onClick={() => onSubmit(threshold as number)}
          disabled={!threshold || isSubmitting}
        >
          <span className={isSubmitting ? "opacity-0" : undefined}>
            {buttonLabel}
          </span>
          {isSubmitting && (
            <div className="absolute top-1/2 left-1/2 -mt-2 -ml-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-r-transparent" />
          )}
        </button>
      </div>
    </div>
  )
}

export default EditAlertThreshold
